import React from "react"
import type { ChannelMemberResponse } from "stream-chat"
import { Text } from "@/elements"
import { MessagesAvatar } from "./MessagesAvatar"

export const AvatarGroup = ({ members }: { members: ChannelMemberResponse[] }) => {
  let content

  if (members.length === 1) {
    const memberIsClient = members?.[0]?.channel_role === "client_channel_member"
    content = (
      <MessagesAvatar
        showClientTag={memberIsClient}
        src={(members?.[0]?.user?.image as string) ?? ""}
        alt={members?.[0]?.user?.name ?? ""}
      />
    )
  } else if (members.length === 2) {
    content = (
      <div className="relative h-full w-full">
        <div className="absolute left-0 top-0">
          <MessagesAvatar
            src={(members?.[0]?.user?.image as string) ?? ""}
            alt={members?.[1]?.user?.name ?? ""}
            size="medium"
          />
        </div>
        <div className="absolute bottom-0 right-0 overflow-hidden rounded-md border-2 border-bg-1">
          <MessagesAvatar
            src={(members?.[1]?.user?.image as string) ?? ""}
            alt={members?.[2]?.user?.name ?? ""}
            size="medium"
            rounded={false}
          />
        </div>
      </div>
    )
  } else if (members.length > 4) {
    content = (
      <>
        <MessagesAvatar
          src={(members?.[0]?.user?.image as string) ?? ""}
          alt={members?.[1]?.user?.name ?? ""}
          size="small"
        />
        <MessagesAvatar
          src={(members?.[1]?.user?.image as string) ?? ""}
          alt={members?.[2]?.user?.name ?? ""}
          size="small"
        />
        <MessagesAvatar
          src={(members?.[2]?.user?.image as string) ?? ""}
          alt={members?.[3]?.user?.name ?? ""}
          size="small"
        />
        <div className="flex h-[30px] w-[24px] items-center justify-center rounded-sm bg-primary-2">
          <Text variant="body3">+{members.length - 3}</Text>
        </div>
      </>
    )
  } else {
    content = (
      <>
        {members.map((member, index) => (
          <MessagesAvatar
            key={index}
            src={(member?.user?.image as string) ?? ""}
            alt={member?.user?.name ?? ""}
            size="small"
          />
        ))}
      </>
    )
  }

  return <div className="flex h-[62px] w-[50px] flex-row flex-wrap gap-[1px]">{content}</div>
}
